import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ProductsService } from 'src/app/services';
import { takeUntil } from 'rxjs/operators';
import { NzNotificationService } from 'ng-zorro-antd';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-products-setting',
  templateUrl: './products-setting.component.html',
  styleUrls: ['./products-setting.component.scss']
})
export class ProductsSettingComponent implements OnInit {

  constructor(
    private notification: NzNotificationService,
    private productService: ProductsService,
    private router: ActivatedRoute
  ) { }
  productId: string;
  managementStatus: number;
  roleCode: string = null;
  checkChangeView = 0;
  openMessage(type: string, title: string, content: any) {
    return this.notification.create(
      type,
      title,
      content
    );
  }

  ngOnInit() {
    this.productId = this.router.snapshot.paramMap.get('id');
    this.productService.getById(this.productId).pipe().subscribe(
      (res) => {
        if (res.code === 1) {
          this.managementStatus = res.data.managementStatus;
          this.roleCode = res.data.roleCode;
          const body: any = {
            managementStatus: this.managementStatus,
            roleCode: this.roleCode
          };
          this.productService.getManagementStatus(body);
        }
      },
      (err) => {
        this.openMessage('error', 'Lỗi !!!', `${err}`);
      },
    );
  }
  changeView(param: number) {
    console.log(param)
    this.checkChangeView = param;
  }
}
